<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      :class="{
        'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <ResourceCenterLayout
        :content-type="[
          'blog',
          'caseStudy',
          'genericEvent',
          'linkedEvent',
          'lumaEvent',
          'spotlight',
          'techTip',
          'video',
          'whatIsNew',
        ]"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup></script>

<style></style>
